import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { passwordStrength as basePasswordStrength, Options } from 'check-password-strength';

export type PasswordStrength = {
    score: number,
    key: string
}

const usePasswordStrength = () => {
    const { t } = useTranslation('common');
    const options = useMemo<Options<PasswordStrength>>(() => [
        {
            id: 0,
            value: {
                key: '',
                score: 0
            },
            minDiversity: 0,
            minLength: 0
        },
        {
            id: 1,
            value: {
                key: t('Molto debole'),
                score: 1
            },
            minDiversity: 1,
            minLength: 0
        },
        {
            id: 2,
            value: {
                key: t('Debole'),
                score: 3
            },
            minDiversity: 2,
            minLength: 6
        },
        {
            id: 3,
            value: {
                key: t('Media'),
                score: 6
            },
            minDiversity: 3,
            minLength: 8
        },
        {
            id: 4,
            value: {
                key: t('Forte'),
                score: 10
            },
            minDiversity: 4,
            minLength: 10
        }
    ], [t]);

    const passwordStrength = useCallback((password:string) => basePasswordStrength<PasswordStrength>(password, options), [options]);

    return {
        passwordStrength
    }
};

export default usePasswordStrength;